import * as api from "app/api/templates"
import Template from "app/models/template"
import { SagaIterator } from "redux-saga"
import { call, put, takeLatest } from "redux-saga/effects"
import { history } from "store"
import * as notificationActions from "../notifications/notifications.actions"
import * as practiceActions from "../practice/practice.actions"
import * as actions from "./templates.actions"
import { handleError } from "../errorHandler/errorHandler.saga"
import { connectTemplateTimeslotsChannel } from "../templateTimeslotsChannel/templateTimeslotsChannel.actions"

export function* getTemplatesFlow(action: actions.GetTemplatesAction): SagaIterator {
  try {
    const response = yield call(api.getTemplates, action.payload.params)
    yield put(actions.getTemplatesSuccess(response && response.data))
  } catch (e) {
    yield put(actions.getTemplatesFail(e))
    yield call(handleError, { error: e })
  }
}

export function* deleteTemplatesByIdFlow(action: actions.DeleteTemplatesByIdAction): SagaIterator {
  try {
    const { id } = action.payload
    yield call(api.deleteTemplatesById, id)
    yield put(actions.deleteTemplatesByIdSuccess())
    yield put(actions.getTemplates())
    yield put(
      notificationActions.show({
        id: "deleteTemplateSuccess",
        message: "confirmationDialog.templates.delete.message",
        variant: "success",
      }),
    )
    history.push("/templates")
  } catch (e) {
    yield put(actions.deleteTemplatesByIdFail(e))
    yield call(handleError, { error: e })
  }
}

export function* postTemplatesFlow(action: actions.PostTemplatesAction): SagaIterator {
  try {
    const { data } = action.payload
    const response = yield call(api.postTemplates, data)
    yield put(actions.postTemplatesSuccess(response && response.data))
    history.push(`/templates/${response.data.id}/edit`)
  } catch (e) {
    yield put(actions.postTemplatesFail(e))
    yield call(handleError, { error: e })
  }
}

export function* getTemplatesByIdFlow(action: actions.GetTemplatesByIdAction): SagaIterator {
  try {
    const response = yield call(api.getTemplatesById, action.payload.id)
    yield put(connectTemplateTimeslotsChannel({ template_id: response && action.payload.id }))
    yield put(practiceActions.getPractice())
    const data: Template = response && response.data
    yield put(actions.getTemplatesByIdSuccess(data))
  } catch (e) {
    if (e && e.response && e.response.status === 404) {
      history.push("/templates")
    }
    yield put(actions.getTemplatesByIdFail(e))
    yield call(handleError, { error: e })
  }
}

export function* putTemplatesFlow(action: actions.PutTemplatesAction): SagaIterator {
  try {
    const { data } = action.payload
    const response = yield call(api.putTemplates, data)
    yield put(actions.putTemplatesSuccess(response && response.data))
  } catch (e) {
    yield put(actions.putTemplatesFail(e))
    yield call(handleError, { error: e })
  }
}

export function* duplicateTemplateFlow(action: actions.DuplicateTemplatesAction): SagaIterator {
  try {
    const { id, name, redirect } = action.payload
    const response = yield call(api.duplicateTemplate, id, name)
    const template: Template = response.data
    yield put(
      notificationActions.show({
        id: "duplicateTemplateSuccess",
        message: "confirmationDialog.templates.duplicate.message",
        variant: "success",
      }),
    )
    if (redirect) {
      history.push(`/templates/${template.id}/edit`)
    }
    yield put(actions.duplicateTemplatesSuccess(template))
  } catch (e) {
    yield put(actions.duplicateTemplatesFail(e))
    yield call(handleError, { error: e })
  }
}

export default function* templatesSaga(): SagaIterator {
  yield takeLatest(actions.Types.GET, getTemplatesFlow)
  yield takeLatest(actions.Types.DELETE, deleteTemplatesByIdFlow)
  yield takeLatest(actions.Types.POST, postTemplatesFlow)
  yield takeLatest(actions.Types.GET_BY_ID, getTemplatesByIdFlow)
  yield takeLatest(actions.Types.PUT, putTemplatesFlow)
  yield takeLatest(actions.Types.DUPLICATE, duplicateTemplateFlow)
}
